export default {
  dsp: 'dsp',
  gtm: 'gtm',
  zillow: 'zillow',
} as const;
